import fetcher from '../../helpers/fetcher';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { unwrapDataResponse } from '../../utils/unwrapDataResponse';

class LocationService {
  private consumerPriceUrl = ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE;

  async getLocations(): Promise<Location[]> {
    const response = await fetcher.get(
      API_ENDPOINTS.LOCATION.GET_LOCATION_LIST,
      undefined,
      undefined,
      this.consumerPriceUrl
    );
    return unwrapDataResponse<Location[]>(response?.data);
  }
}

export const locationService = new LocationService();
